import { render, staticRenderFns } from "./ClinicEditModal.vue?vue&type=template&id=61c50580&scoped=true"
import script from "./ClinicEditModal.vue?vue&type=script&lang=js"
export * from "./ClinicEditModal.vue?vue&type=script&lang=js"
import style0 from "./ClinicEditModal.vue?vue&type=style&index=0&id=61c50580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c50580",
  null
  
)

export default component.exports